<template>
    <div class="bg-bluish">
        <!-- HERO -->
        <section class="relative min-h-screen overflow-hidden bg-[#050505] text-white">
            <div class="absolute inset-0">
                <div
                    class="h-full w-full bg-[url('@img/backgrounds/pattern-4.webp')] bg-cover bg-center opacity-80"
                ></div>

                <div class="absolute inset-0 bg-black/70"></div>

                <div
                    class="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,196,0,0.16),transparent_28%),radial-gradient(circle_at_85%_18%,rgba(255,196,0,0.12),transparent_22%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.04),transparent_26%)]"
                ></div>

                <div
                    class="absolute -left-24 top-24 h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>
                <div
                    class="absolute right-[-80px] top-[-40px] h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"
                ></div>

                <div class="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#0d141b] to-transparent"></div>
            </div>

            <div class="relative container flex min-h-screen flex-col justify-center pt-[90px] pb-[40px] md:pt-20">
                <div class="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10">
                    <div class="lg:col-span-7">
                        <Breadcrumbs theme="dark"/>

                        <div
                            class="mb-5 inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2"
                        >
                            <span class="h-2 w-2 rounded-full bg-baseColor shadow-[0_0_18px_rgba(255,196,0,0.8)]"></span>
                            <p class="text-xs font-semibold uppercase tracking-[0.14em] text-white/65">
                                X-DEVS · о компании
                            </p>
                        </div>

                        <h1
                            class="max-w-4xl text-2xl font-extrabold leading-[1.04] tracking-[-0.04em] md:text-4xl"
                        >
                            Создаём
                            <span class="text-baseColor">цифровые решения</span>
                            для автоматизации, управления и роста бизнеса
                        </h1>

                        <p
                            class="quote mt-6 max-w-3xl text-xs leading-[1.56] text-white/82 md:text-sm"
                        >
                            X-DEVS — IT-компания, которая проектирует и разрабатывает
                            рабочие системы для бизнеса: сайты, CRM, ERP, внутренние
                            кабинеты, аналитические панели, интеграции и инструменты
                            автоматизации. <br/><br/>Мы помогаем компаниям выстраивать понятную
                            цифровую инфраструктуру, сокращать ручную работу и делать
                            процессы прозрачнее, быстрее и управляемее.
                        </p>

                        <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
                            <div
                                v-for="tag in heroTags"
                                :key="tag"
                                class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75"
                            >
                                <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                                {{ tag }}
                            </div>
                        </div>

                        <div class="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
                            <div
                                @click.prevent="callbackStore.showBaseCallbackPopup()"
                                class="inline-flex h-[54px] w-full cursor-pointer items-center justify-center rounded-2xl bg-baseColor px-6 text-[16px] font-bold text-black shadow-[0_12px_40px_rgba(255,196,0,0.22)] transition hover:-translate-y-0.5 hover:bg-[#e6b000] sm:w-auto sm:min-w-[230px]"
                            >
                                Обсудить проект
                            </div>

                            <div class="flex items-center gap-3 text-sm text-white/55">
                                <span class="h-px w-10 bg-white/15"></span>
                                Разработка, интеграции и автоматизация под реальные процессы
                            </div>
                        </div>

                        <div class="max-md:hidden mt-12 grid max-w-[820px] grid-cols-1 gap-4 sm:grid-cols-3">
                            <div
                                v-for="item in stats"
                                :key="item.label"
                                class="group relative overflow-hidden rounded-[24px] border border-white/10 bg-white/[0.04] p-5 transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:bg-white/[0.06]"
                            >
                                <div
                                    class="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-baseColor/70 to-transparent"
                                ></div>

                                <div class="text-[34px] font-extrabold leading-none text-baseColor">
                                    {{ item.value }}
                                </div>

                                <p class="mt-3 text-[15px] leading-[1.6] text-white/82">
                                    {{ item.label }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- WHO WE ARE -->
        <section class="relative overflow-hidden py-10 md:py-20">
            <div class="absolute inset-0 opacity-40">
                <img
                    src="@img/backgrounds/pattern-2.webp"
                    alt=""
                    class="h-full w-full object-cover"
                />
            </div>

            <div class="relative container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Кто мы и как смотрим на разработку
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        О компании
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 lg:grid-cols-12">
                    <div class="lg:col-span-7">
                        <div
                            class="relative overflow-hidden rounded-[30px] border border-white/60 bg-white/85 p-7 shadow-[0_10px_35px_rgba(17,17,17,0.04)] md:p-9"
                        >
                            <div
                                class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl"
                            ></div>

                            <div class="relative space-y-5 max-md:text-sm leading-[1.5] text-[#5d7184]">
                                <p>
                                    <span class="font-extrabold text-[#111111]">X-DEVS</span>
                                    специализируется на автоматизации бизнес-процессов,
                                    разработке CRM и ERP-систем, внутренних сервисов,
                                    аналитических решений, клиентских кабинетов, сайтов
                                    и интеграций между ключевыми системами компании.
                                </p>

                                <p>
                                    Мы подходим к проектам не как к набору страниц или
                                    форм, а как к инструментам, которые должны решать
                                    практические задачи бизнеса: ускорять процессы,
                                    снижать нагрузку на сотрудников, повышать прозрачность
                                    данных и обеспечивать контроль над операционной работой.
                                </p>

                                <p>
                                    Наш опыт охватывает проекты для компаний, где особенно
                                    важны надёжность, управляемость, понятная логика,
                                    интеграция с внешними сервисами и возможность
                                    постепенного роста продукта без необходимости
                                    переделывать всю систему заново.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="lg:col-span-5">
                        <div class="grid grid-cols-1 gap-4">
                            <div
                                v-for="item in companyFacts"
                                :key="item.title"
                                class="group relative overflow-hidden rounded-[26px] border border-white/60 bg-white/85 p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-md"
                            >
                                <div
                                    class="absolute right-0 top-0 h-20 w-20 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                                ></div>

                                <div class="relative">
                                    <div class="text-xs font-semibold uppercase tracking-[0.14em] text-[#7a8795]">
                                        {{ item.label }}
                                    </div>
                                    <div class="mt-3 text-[22px] font-extrabold leading-[1.25] text-[#172f45]">
                                        {{ item.title }}
                                    </div>
                                    <p class="mt-3 max-md:text-sm leading-[1.5] text-[#5f7385]">
                                        {{ item.text }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- VALUES / ADVANTAGES -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что нас отличает
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-5 lg:grid-cols-3">
                    <div
                        v-for="(item, index) in advantages"
                        :key="item.title"
                        class="group relative overflow-hidden rounded-[30px] border border-[#e7ebef] bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/20 hover:shadow-md"
                    >
                        <div
                            class="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-baseColor via-[#ffd85a] to-transparent"
                        ></div>

                        <div class="mb-5 flex items-center gap-4">
                            <div
                                class="flex h-[58px] min-w-[58px] items-center justify-center rounded-2xl bg-[#111111] text-2xl font-extrabold text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>

                            <h3 class="pt-1 md:text-lg font-extrabold leading-[1.35] text-[#20262d]">
                                {{ item.title }}
                            </h3>
                        </div>

                        <p class="max-md:text-sm leading-[1.5] text-[#6b7d8e]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- DIRECTIONS -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Основные направления работы
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Что мы делаем
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="(item, index) in directions"
                        :key="item.title"
                        class="group relative overflow-hidden rounded-[30px] border border-[#e4e8ec] bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/25 hover:shadow-md"
                    >
                        <div class="mb-5 flex items-center justify-between gap-4">
                            <h3 class="text-lg md:text-xl font-extrabold leading-[1.3] text-[#172f45]">
                                {{ item.title }}
                            </h3>

                            <div
                                class="flex h-10 w-10 items-center justify-center rounded-xl bg-baseColor/12 text-sm font-extrabold text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                        </div>

                        <p class="max-md:text-sm leading-[1.5] text-[#63788b]">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- INDUSTRIES -->
        <section class="bg-white py-10 md:py-20">
            <div class="container">
                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        С кем работаем
                    </h2>
                    <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
                </div>

                <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="(item, index) in industries"
                        :key="item.title"
                        class="group relative flex h-full flex-col overflow-hidden rounded-[30px] border border-[#dfe6ec] bg-[#fbfcfd] p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/30 hover:bg-white hover:shadow-md"
                    >
                        <div class="absolute inset-x-0 top-0 h-1 bg-baseColor"></div>

                        <div
                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl transition duration-300 group-hover:bg-baseColor/15"
                        ></div>

                        <div class="relative">
                            <div
                                class="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#111111] text-2xl font-extrabold leading-none tracking-tight text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                        </div>

                        <h3
                            class="relative mt-5 text-xl font-extrabold leading-tight text-[#172f45]"
                        >
                            {{ item.title }}
                        </h3>

                        <p class="relative mt-3 text-sm leading-[1.5] text-[#63788b]">
                            {{ item.text }}
                        </p>

                        <div class="mt-auto flex items-center gap-2 pt-5">
                            <div class="h-1.5 w-1.5 rounded-full bg-baseColor"></div>
                            <div class="h-px flex-1 bg-[#e3e8ee]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- PROCESS -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Как строится работа над проектом
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Как мы работаем
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-5">
                    <div
                        v-for="(step, index) in steps"
                        :key="step.title"
                        class="group relative overflow-hidden rounded-[28px] border border-[#e6ebf0] bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/25 hover:shadow-md"
                    >
                        <div class="mb-5 flex items-center gap-3">
                            <div
                                class="flex h-10 w-10 items-center justify-center rounded-xl bg-[#111111] text-sm font-extrabold text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                            <div class="h-px flex-1 bg-[#e5ebf0]"></div>
                        </div>

                        <h3 class="text-[18px] font-extrabold leading-[1.35] text-[#172f45]">
                            {{ step.title }}
                        </h3>

                        <p class="mt-3 text-sm  leading-[1.5] text-[#587086]">
                            {{ step.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- WHY CLIENTS COME -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <p
                    class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3 md:text-sm"
                >
                    Зачем к нам обращаются
                </p>

                <div class="mb-10 flex items-center gap-6 md:mb-14">
                    <h2
                        class="text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:text-4xl"
                    >
                        Какие задачи решаем
                    </h2>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                    <div
                        v-for="(item, index) in problems"
                        :key="item"
                        class="group relative overflow-hidden rounded-[28px] border border-[#e6ebf0] bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-baseColor/25 hover:shadow-md"
                    >
                        <div class="mb-5 flex items-center gap-3">
                            <div
                                class="flex h-10 w-10 items-center justify-center rounded-xl bg-[#111111] text-sm font-extrabold text-baseColor"
                            >
                                {{ String(index + 1).padStart(2, '0') }}
                            </div>
                            <div class="h-px flex-1 bg-[#e5ebf0]"></div>
                        </div>

                        <p class="max-md:text-sm leading-[1.5] text-[#587086]">
                            {{ item }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- CTA -->
        <section class="py-10 md:pb-20">
            <div class="container">
                <div class="relative overflow-hidden rounded-[34px] bg-[#0b0b0b] shadow-[0_20px_60px_rgba(0,0,0,0.18)]">
                    <div class="absolute inset-0">
                        <div
                            class="h-full w-full bg-[url('@img/backgrounds/pattern-3.webp')] bg-cover bg-center opacity-15"
                        ></div>
                        <div
                            class="absolute inset-0 bg-[radial-gradient(circle_at_right_top,rgba(255,196,0,0.18),transparent_24%),radial-gradient(circle_at_left_bottom,rgba(255,255,255,0.05),transparent_30%)]"
                        ></div>
                        <div
                            class="absolute left-10 top-10 h-32 w-32 rounded-full bg-baseColor/10 blur-3xl"
                        ></div>
                    </div>

                    <div
                        class="relative grid grid-cols-1 gap-8 px-6 py-8 md:px-10 md:py-10 lg:grid-cols-[minmax(0,1.4fr)_auto] lg:items-center lg:gap-10 xl:px-12"
                    >
                        <div class="max-w-3xl">
                            <div
                                class="mb-4 inline-flex rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-white/50"
                            >
                                Обсудить проект
                            </div>

                            <h2
                                class="text-2xl font-extrabold leading-tight tracking-tight text-white md:text-3xl lg:text-4xl"
                            >
                                Ищете команду, которая
                                <span class="text-baseColor">понимает не только код, но и бизнес-задачи</span>?
                            </h2>

                            <p class="mt-4 max-w-2xl text-sm leading-[1.8] text-white/70 md:text-base">
                                Обсудим ваш проект, процессы компании и задачи, которые
                                нужно автоматизировать. Предложим понятный подход,
                                архитектуру и сценарий развития решения.
                            </p>
                        </div>

                        <div class="flex lg:justify-end">
                            <button
                                @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'О компании / Обсудить проект' })"
                                class="inline-flex h-14 w-full items-center justify-center rounded-2xl bg-baseColor px-6 text-sm font-bold uppercase tracking-wide text-black shadow-[0_12px_40px_rgba(255,196,0,0.22)] transition hover:-translate-y-0.5 hover:bg-baseColor/85 sm:w-auto sm:min-w-72"
                            >
                                Оставить заявку
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { useCallbackStore } from "@js/store/CallbackStore.js";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

const callbackStore = useCallbackStore();

const heroTags = [
    'CRM и ERP системы',
    'Внутренние сервисы',
    'Интеграции и автоматизация',
];

const stats = [
    {
        value: '7+',
        label: 'Лет на IT рынке',
    },
    {
        value: '10+',
        label: 'Отраслевых решений',
    },
    {
        value: '20+',
        label: 'Штатных сотрудников',
    },
];

const heroCards = [
    {
        label: 'Экспертиза',
        title: 'Разработка систем, где важны логика, данные и надёжность процессов',
    },
    {
        label: 'Подход',
        title: 'Погружение в бизнес-задачи, а не работа только на уровне интерфейса',
    },
    {
        label: 'Результат',
        title: 'Инструменты, которые помогают управлять, контролировать и масштабировать',
    },
];

const companyFacts = [
    {
        label: 'Специализация',
        title: 'Автоматизация и цифровая инфраструктура',
        text: 'Проектируем решения для компаний, которым нужны не просто страницы, а рабочие системы с понятной логикой и долгим жизненным циклом.',
    },
    {
        label: 'Формат работы',
        title: 'От идеи до внедрения',
        text: 'Участвуем в проекте на всех этапах: аналитика, архитектура, интерфейсы, backend, интеграции, запуск и дальнейшее развитие.',
    },
    {
        label: 'Ориентация',
        title: 'Под реальные процессы бизнеса',
        text: 'Каждое решение собирается с учётом специфики команды, ролей, данных, документов, заявок, клиентов и внутренних сценариев компании.',
    },
];

const advantages = [
    {
        title: 'Смотрим на разработку как на бизнес-инструмент',
        text: 'Для нас продукт должен не просто существовать, а помогать компании ускорять процессы, упрощать управление и давать измеримый эффект.',
    },
    {
        title: 'Продумываем архитектуру заранее',
        text: 'Разбираем роли, модули, данные, интеграции и сценарии роста ещё до активной реализации, чтобы не строить систему хаотично.',
    },
    {
        title: 'Создаём решения, которые можно развивать',
        text: 'Закладываем основу для дальнейшего масштабирования, чтобы проект можно было дополнять функциями и сервисами без полной переделки.',
    },
];

const directions = [
    {
        title: 'Сайты и веб-платформы',
        text: 'Разрабатываем корпоративные сайты, сервисы, каталоги, клиентские кабинеты и другие веб-решения под задачи компании.',
    },
    {
        title: 'CRM и ERP системы',
        text: 'Создаём инструменты для работы с клиентами, заказами, документами, финансами, производственными и внутренними процессами.',
    },
    {
        title: 'Внутренние сервисы',
        text: 'Разрабатываем панели управления, кабинеты сотрудников, административные интерфейсы и системы для повседневной операционной работы.',
    },
    {
        title: 'Интеграции',
        text: 'Связываем сайт и внутренние системы с CRM, телефонией, оплатами, API, мессенджерами, аналитикой и другими внешними сервисами.',
    },
    {
        title: 'Автоматизация процессов',
        text: 'Упрощаем рутину, сокращаем ручные действия, автоматизируем уведомления, статусы, очереди задач и обмен данными между системами.',
    },
    {
        title: 'Аналитика и контроль',
        text: 'Помогаем собирать ключевые данные, строить дашборды, отслеживать воронки, процессы, обращения и показатели эффективности.',
    },
];

const industries = [
    {
        title: 'Переработка вторсырья',
        text: 'Решения для компаний, где важны приёмка, логистика, документы, цены, заявки, аналитика и управление большим количеством операций.',
    },
    {
        title: 'Логистика и транспорт',
        text: 'Системы для контроля заявок, маршрутов, статусов, внутренних процессов и координации между отделами и участниками цепочки.',
    },
    {
        title: 'Производство',
        text: 'Инструменты для прозрачности процессов, работы с заказами, документами, внутренними этапами и операционной загрузкой.',
    },
    {
        title: 'Финансовые сервисы',
        text: 'Решения, где особенно важны надёжность, контроль доступа, работа с данными, стабильность процессов и понятная логика действий.',
    },
    {
        title: 'Торговля и дистрибуция',
        text: 'Цифровые инструменты для каталогов, заказов, учёта, клиентских кабинетов, интеграций и автоматизации внутренних операций.',
    },
    {
        title: 'Индивидуальные B2B проекты',
        text: 'Берёмся за проекты со сложной бизнес-логикой, нетиповыми ролями, интеграциями и требованиями к дальнейшему масштабированию.',
    },
];

const steps = [
    {
        title: 'Погружение в задачу',
        text: 'Изучаем бизнес, процессы, ограничения, роли и цели, чтобы понять, какое решение действительно нужно компании.',
    },
    {
        title: 'Аналитика и проектирование',
        text: 'Формируем структуру системы, логику работы, состав модулей, интеграции и сценарий дальнейшей реализации.',
    },
    {
        title: 'Разработка и внедрение',
        text: 'Создаём интерфейсы, backend, права доступа, бизнес-логику, процессы обработки данных и техническую основу проекта.',
    },
    {
        title: 'Интеграции и запуск',
        text: 'Подключаем сторонние сервисы, проверяем стабильность работы и готовим продукт к полноценному использованию.',
    },
    {
        title: 'Развитие и масштабирование',
        text: 'После запуска помогаем усиливать продукт, добавлять новые модули и адаптировать систему под рост компании.',
    },
];

const problems = [
    'Процессы внутри компании разрознены и держатся на таблицах, переписках и ручной передаче данных.',
    'Нет единой системы для управления клиентами, заявками, документами, задачами и внутренними ролями.',
    'Бизнес растёт, но текущие цифровые инструменты уже не справляются с объёмом операций и нагрузкой.',
    'Нужно объединить сайт, CRM, аналитику, оплату, уведомления и другие сервисы в единую рабочую логику.',
    'Команде нужен инструмент, который учитывает специфику процессов, а не навязывает чужие ограничения.',
    'Важно не просто внедрить решение, а создать фундамент для дальнейшего развития и масштабирования.',
];
</script>
